export default (number) => {
  const formatter = new Intl.NumberFormat('ru');
  if (number === undefined || number === null || Number.isNaN(number)) {
    return '⌛'; // can be 'Loading' or whatever
  }
  return formatter.format(number);
};
